<template>
  <div class="MyBusinessCard">
    <div class="noOrders"
         v-if="orderList.length == 0">
      <div class="imageEmptyStock">
        <img src="../../../assets/images/orderEmpty.png"
             alt />
      </div>
      <div v-if="!firstLoading">还没有订单哦...</div>
      <van-loading v-else
                   type="spinner" />
    </div>
    <div class="scroll"
         v-if="orderList.length > 0">
      <van-list v-model="loading"
                :finished="finished"
                finished-text="没有更多了~"
                @load="onLoad"
                :immediate-check="false"
                class="cardDetailList">
        <div v-for="(item, index) in orderList"
             :key="index">
          <div class="cardItem">
            <div class="flex cardItem_box">
              <div class="order_list_img">
                <img :src="item.goodsPicture"
                     alt="">
              </div>
              <div class="orderItemWidth">
                <div class="ellipsisText"
                     id="order_name">
                  {{ item.goodsName }}
                </div>
                <div class="detailSpec">
                  {{ item.goodsSpecificationName }}
                </div>
                <div class="smallSize">
                  累计购买数量：{{ item.buyNumber }}
                </div>
                <div class="order_buy_time">
                  最后购买时间：{{ item.dateTime}}
                </div>
              </div>
            </div>
          </div>
        </div>

      </van-list>
    </div>
    <van-overlay :show="isLoading">
      <div class="wrapper">
        <loading v-if="isLoading == true"></loading>
      </div>
    </van-overlay>
  </div>
</template>
<script>
// import service from "../../api/order/index";
import service from "../../api/myShare/index";
import loading from "../loading/loading";
import {
  Card,
  Panel,
  List,
  Loading,
  Form,
  Field,
  Overlay,
  Icon,
  Popup, CellGroup, Toast, Dialog, Button, Notify, ImagePreview
} from "vant";
import { mapGetters } from "vuex";
import vueQr from "vue-qr";
export default {
  data () {
    return {
      imageUrl: '',
      status: false,
      fileList: [],
      pictureList: [],
      userAllMes: {
        pictureUrlList: [],
      },
      isLoading: true, //loading状态
      show: false,
      orderStatusId: "",
      orderList: [],
      noDate: false, //这是一个判断是否加载的开关
      arr: [],
      page: 1,
      pageSize: 20,
      loading: false,
      finished: false,
      orderStatusText: "",
      firstLoading: true,
    };
  },
  components: {
    [Card.name]: Card,
    [Panel.name]: Panel,
    [List.name]: List,
    [Loading.name]: Loading,
    [Form.name]: Form,
    [Field.name]: Field,
    [Overlay.name]: Overlay,
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    [CellGroup.name]: CellGroup,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    [Notify.name]: Notify,
    [ImagePreview.Component.name]: ImagePreview.Component,
    vueQr,
    loading
  },
  props: {
    msg: {
      type: String,
      default: "这是默认值"
    }
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  mounted () {
    this.init()
    console.log(this.msg, "this.msg")
  },
  methods: {
    onLoad () {
      this.page++;
      this.getList().then((orderList) => {
        this.orderList = this.orderList.concat(orderList.items);

        this.loading = false;
        if (orderList.totalCount <= this.orderList.length) {
          this.finished = true;
        }
      });
    },
    init () {
      this.page = 1;
      this.firstLoading = true;
      this.loading = false;
      this.getList()
        .then((orderList) => {
          setTimeout(() => {
            this.isLoading = false;
          }, 500);
          this.orderList = orderList.items;
          this.finished = false;
          this.firstLoading = false;
          if (orderList.totalCount <= this.orderList.length) {
            this.finished = true;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.isLoading = false;
        });
    },
    // onOrderClick(orderId) {
    //     if (this.orderStatusId == "") {
    //         this.orderStatusId = "all";
    //     }
    //     this.$router.push({
    //         name: "orderDetail",
    //         query: { id: orderId, orderStatusId: this.orderStatusId }
    //     });
    // },
    getList () {
      return new Promise((resolve, reject) => {
        service
          .detail(this.msg, this.page, this.pageSize)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            // reject();
          });
      });
    },
  },
};
</script>
<style lang="less" scoped>
@deep: ~'>>>';

// 更改组件图片大小
@{deep}.van-card .van-card__thumb {
  width: 70px;
  height: 70px;
}

@{deep}.van-card .van-card__thumb img {
  width: 70px;
  height: 70px;
}
.order_list_img {
  width: 86px;
  height: 86px;
  margin-right: 12px;
}
.smallSize {
  margin-bottom: 12px;
  height: 12px;
  line-height: 12px;
}
.order_buy_time {
  font-size: 12px;
  height: 12px;
  line-height: 12px;
}
#order_name {
  height: 14px;
  line-height: 14px;
}
.van-card__num {
  margin-bottom: 5px;
  float: left;
}

[class*='van-hairline']::after {
  border: none;
}

.cardDetailList {
  .van-card {
    background: #fff;
    margin: 0 4.26667vw;
    padding: 4vw 0;
  }
}

.MyBusinessCard {
  //   width: 327px;
  height: 500px;
  padding: 0 12px 0 12px;
  overflow-y: scroll;

  .noOrders {
    padding-top: 20vw;
  }
  .scroll {
    padding: 53px 0 0 0;
  }

  // 每一个商品
  .cardItem {
    height: auto;
    background: #ffffff;
    box-shadow: 0px 4px 8px 0px #e6e6e6;
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    border: 1px solid #ececec;
    margin-bottom: 8px;
  }
  .cardItem_box {
    width: 303px;
    padding: 16px 12px;
  }

  // 没有更多了
  @{deep}.van-list__finished-text {
    height: 30px;
    line-height: 25px;
    margin-top: 8px;
  }

  // 提示
  .tips {
    margin: 16px 0;
    color: #999999;
    font-size: 12px;
  }

  /* 在 600 像素或更小的屏幕上，将背景色设置为橄榄色 */
  // @media screen and (max-width: 305px) {
  //   .orderItemWidth {
  //     width: 130px;
  //   }
  // }

  // @media screen and (min-width: 305px) and (max-width: 325px) {
  //   .orderItemWidth {
  //     width: 150px;
  //   }
  // }

  // @media screen and (min-width: 325px) and (max-width: 365px) {
  //   .orderItemWidth {
  //     width: 160px;
  //   }
  // }

  // @media screen and (min-width: 365px) and (max-width: 380px) {
  //   .orderItemWidth {
  //     width: auto;
  //   }
  // }

  // @media screen and (min-width: 380px) and (max-width: 395px) {
  //   .orderItemWidth {
  //     width: 203px;
  //   }
  // }

  // @media screen and (min-width: 395px) and (max-width: 415px) {
  //   .orderItemWidth {
  //     width: 210px;
  //   }
  // }

  // @media screen and (min-width: 415px) and (max-width: 430px) {
  //   .orderItemWidth {
  //     width: 230px;
  //   }
  // }
  .orderItemWidth {
    width: 203px;
  }
  // 描述
  .detailSpec {
    font-size: 12px;
    color: #999999;
    margin: 12px 0;
    height: 12px;
    line-height: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
  